import React, { useState, useEffect, useLayoutEffect } from 'react';
// import { First, Second, Third, Fourth, Fifth } from '../../smart/utils/images-loader/ImagesLoader';
// import { ImagesLoader } from '../../smart/utils/images-loader/ImagesLoader';
import { Link } from 'react-router-dom';
import { Loader } from '../utils/loader/Loader';
import { Selector } from '../../smart/utils/filenames-loader/Selector';


type props = {}

export const GalleryItem = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);
    // console.log(props.filename, props.index)
    let myServiceName : string = Selector.selectName(props.filename, props.index);
    let myServiceRouter: string = Selector.selectRouter(props.filename, props.index);

    useLayoutEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {

        return <Loader />;
    }
    else
        return <div className="col-xl-4 col-lg-6 grid-item cat1 col-md-6">
            <div className="single-gallery mb-20">
                <div className="portfolio-img">
                    <h2>{myServiceName}</h2>
                    <img src={props.serviceImg} alt="" />
                </div>
                <div className="gallery_hover">
                    <li><Link onClick={() => {
                            // console.log(myServiceName)
                            props.clickhandler(myServiceName)
                        }
                    }
                    // to={'/Service'} className="nav-link"> {myServiceName} </Link></li>
                    to={myServiceRouter} className="nav-link"> MORE... </Link></li>
                    {/* <h3>Product Branding</h3>
                    <span>Branding</span> */}
                </div>
            </div>
        </div>
}